import * as Sentry from '@sentry/browser';

let sentryIsInitialized = false;
const ignoreErrors = ['ResizeObserver loop limit exceeded'];
const releasePlaceholder = 'BUILD_NUMBER_PLACEHOLDER';

const init = (dsn) => {
  const config = {
    dsn,
    ignoreErrors,
  };

  // eslint-disable-next-line no-underscore-dangle
  const release = window.__WS__BUILD_NUMBER;
  if (release !== releasePlaceholder) {
    config.release = release;
  }

  Sentry.init(config);
  sentryIsInitialized = true;
};
const isInit = () => sentryIsInitialized;

const setSiteId = (siteId) => {
  if (siteId) {
    Sentry.setTag('site-id', siteId);

    // eslint-disable-next-line no-console
    console.info(`Sentry set site ID: ${siteId}`);
  }
};

const setUserId = (id) => {
  if (id) {
    Sentry.setUser({ id });

    // eslint-disable-next-line no-console
    console.info(`Sentry set user ID: ${id}`);
  }
};

const getInstance = () => Sentry;

const captureException = (error, additionalInfo) => {
  if (!sentryIsInitialized) return;

  Sentry.withScope((scope) => {
    const { request, response } = error;
    scope.setExtras({
      ...(additionalInfo && { additionalInfo }),
      ...(request && { request: JSON.stringify(request) }),
      ...(response && { response: JSON.stringify(response) }),
    });
    Sentry.captureException(error);
  });
};

export default {
  init,
  getInstance,
  setSiteId,
  setUserId,
  isInit,
  captureException,
};
